import * as fromDatatype from "../datatype-library/index";

export interface bl_cms_calendar_event_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  employee_hdr_guid: fromDatatype.GuidDataFieldInterface;
  event_code: fromDatatype.VarcharDatatypeInterface;
  event_type: fromDatatype.VarcharDatatypeInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  timezone: fromDatatype.VarcharDatatypeInterface;
  visibility_setting: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  icon_colour: fromDatatype.VarcharDatatypeInterface;
  venue_address: fromDatatype.VarcharDatatypeInterface;
  venue_map_url: fromDatatype.VarcharDatatypeInterface;
  venue_gps: fromDatatype.VarcharDatatypeInterface;
  venue_name: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  notification_json: fromDatatype.JsonDatatypeInterface;
  is_full_day: boolean;
  start_date: fromDatatype.TimestampTzDatatypeInterface;
  end_date: fromDatatype.TimestampTzDatatypeInterface;
  image_thumbnail_guid: fromDatatype.GuidDataFieldInterface;
  image_poster_guid: fromDatatype.GuidDataFieldInterface;
  post_hdr_guid: fromDatatype.GuidDataFieldInterface;
  cms_post_guid: fromDatatype.GuidDataFieldInterface;
  recurring_group_01_guid: fromDatatype.GuidDataFieldInterface;
  recurring_group_02_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  rrule: fromDatatype.VarcharDatatypeInterface;
  is_recurring: boolean;
  recurring_update_type: fromDatatype.VarcharDatatypeInterface;
  default_calendar_hdr_guid: fromDatatype.GuidDataFieldInterface;
  facility_hdr_guid: fromDatatype.GuidDataFieldInterface;
  activity_hdr_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_cms_calendar_event_hdr_RowClass
  implements bl_cms_calendar_event_hdr_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  employee_hdr_guid: fromDatatype.GuidDataFieldInterface;
  event_code: fromDatatype.VarcharDatatypeInterface;
  event_type: fromDatatype.VarcharDatatypeInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  timezone: fromDatatype.VarcharDatatypeInterface;
  visibility_setting: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  icon_colour: fromDatatype.VarcharDatatypeInterface;
  venue_address: fromDatatype.VarcharDatatypeInterface;
  venue_map_url: fromDatatype.VarcharDatatypeInterface;
  venue_gps: fromDatatype.VarcharDatatypeInterface;
  venue_name: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  notification_json: fromDatatype.JsonDatatypeInterface;
  is_full_day: boolean;
  start_date: fromDatatype.TimestampTzDatatypeInterface;
  end_date: fromDatatype.TimestampTzDatatypeInterface;
  image_thumbnail_guid: fromDatatype.GuidDataFieldInterface;
  image_poster_guid: fromDatatype.GuidDataFieldInterface;
  post_hdr_guid: fromDatatype.GuidDataFieldInterface;
  cms_post_guid: fromDatatype.GuidDataFieldInterface;
  recurring_group_01_guid: fromDatatype.GuidDataFieldInterface;
  recurring_group_02_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  rrule: fromDatatype.VarcharDatatypeInterface;
  is_recurring: boolean;
  recurring_update_type: fromDatatype.VarcharDatatypeInterface;
  default_calendar_hdr_guid: fromDatatype.GuidDataFieldInterface;
  facility_hdr_guid: fromDatatype.GuidDataFieldInterface;
  activity_hdr_guid: fromDatatype.GuidDataFieldInterface;
}
